<template>
	<div style="width:90%"> 
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<!-- <el-form-item label="用户名称" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.username" placeholder="请输入用户名称"></el-input>
					</el-form-item> -->
					<el-form-item label="店铺名称" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.storeName" placeholder="请输入店铺名称"></el-input>
					</el-form-item>
				 

					<!-- <el-form-item label="是否推存" class='tiny' cleartable>
						<el-select v-model="searchInfo.isHot" placeholder="请选择">
							<el-option key="0" label="是" :value="true">是</el-option>
							<el-option key="1" label="否" :value="false">否</el-option>
						</el-select>       
					</el-form-item> -->

					<el-form-item label="审核状态" class='tiny' cleartable>
						<el-select v-model="searchInfo.authStatus" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="0" label="待审核" :value="0">待审核</el-option>
							<el-option key="1" label="通过" :value="1">通过</el-option>
							<el-option key="2" label="驳回" :value="2">驳回</el-option>
							<el-option key="3" label="加盟到期待续约" :value="3">加盟到期待续约</el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item label="店铺状态" class='tiny' cleartable>
						<el-select v-model="searchInfo.status" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="0" label="停用" :value="0"></el-option>
							<el-option key="1" label="正常" :value="1"></el-option>
						</el-select>
					</el-form-item>

					<!-- <el-form-item label="店铺属性" class='tiny' cleartable>
						<el-select v-model="searchInfo.storeType" placeholder="请选择">
							<el-option key="0" label="线上店铺" :value="1"></el-option>
							<el-option key="1" label="线下店铺" :value="2"></el-option>
						</el-select>
					</el-form-item> -->

					<!-- <el-form-item label="排序方式" class='tiny' cleartable>
						<el-select v-model="searchInfo.orderType" placeholder="默认创建时间降序">
							<el-option key="0" label="更新时间降序" value="0">更新时间降序</el-option>
							<el-option key="1" label="创建时间升序" value="1">创建时间升序</el-option>
							<el-option key="2" label="创建时间降序" value="2">创建时间降序</el-option>
						</el-select>
					</el-form-item> -->

					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
						<!-- 	<el-button type="primary" @click="dialogVisibleFun();title='新增'">新增店铺
							</el-button> -->
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>


		<el-table :data="storeList.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">

			<!-- <el-table-column type="expand">
				<template slot-scope="props">
					<el-form label-position="left" inline class="demo-table-expand">
						<el-form-item label="经营类别">
							<span>{{ props.row.className }}</span>
						</el-form-item>
						<el-form-item label="销售额">
							<span>{{ props.row.storeTotalsales }} CNY</span>
						</el-form-item>

						<el-form-item label="销售收入总额">
							<span>{{ props.row.storeTotalsales }} CNY</span>
						</el-form-item>

						<el-form-item label="收入未提现">
							<span>{{ props.row.storeTotalsales }} CNY</span>
						</el-form-item>
						<el-form-item label="联系人">
							<span>{{props.row.linkUser?props.row.linkUser:'无'}}</span>
						</el-form-item>
						<el-form-item label="联系方式">
							<span>{{props.row.phone?props.row.phone:'无'}}</span>
						</el-form-item>
						<el-form-item label="地址">
							<span v-if="props.row.province">{{ props.row.province }} {{props.row.city}} {{props.row.area}}
								{{props.row.address}}</span>
							<span v-else>无</span>
						</el-form-item>
					
						<el-form-item label="简介">
							<span>{{props.row.storeIntro?props.row.storeIntro:'无'}}</span>
						</el-form-item>

						<el-form-item v-if="props.row.authStatus==2" label="驳回原因">
							<span>{{ props.row.refuseReason }}</span>
						</el-form-item>
						
						<el-form-item v-if="props.row.status==0" label="禁用说明">
							<span>{{ props.row.refuseReason }}</span>
						</el-form-item>

					</el-form>
				</template>
			</el-table-column> -->

			<el-table-column prop="storeName" label="店铺名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="storeLogo" label="店铺LOGO" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<img :src="scope.row.storeLogo" style="width: 60px;height: 60px;border-radius: 10px;" />
				</template>
			</el-table-column>
			<el-table-column prop="linkUser" label="联系人" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="phone" label="电话" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="address" label="地址" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="businessHours" label="经营时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="applyMemo" label="加盟备注" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button v-if="scope.row.applyMemo" @click="look(scope.row.applyMemo)">查看</el-button>
					<span v-else>暂无</span>
				</template>
			</el-table-column>
			<el-table-column  label="加盟时长" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					
					<span v-if="scope.row.joinTime">{{ leaveTime(scope.row.joinTime) }} ~ {{ leaveTime(scope.row.endTime) }}</span>
					<span v-else>暂无</span>
				</template>
			</el-table-column>
			<el-table-column label="加盟费" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.franchiseFee==0">免费</span>
					<span v-else>￥ {{scope.row.franchiseFee}}</span>
				</template>
			</el-table-column>

			<!-- <el-table-column prop="isHot" label="是否推荐" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.isHot">推荐</p>
					<p v-else>不推荐</p>
				</template>
			</el-table-column> -->

			<el-table-column prop="authStatus" label="审核状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.authStatus==0" style="color:#E6A23C;font-weight: bold;">待审核</p>
					<p v-if="scope.row.authStatus==1" style="color:#67C23A;font-weight: bold;">通过</p>
					<p v-if="scope.row.authStatus==2" style="color:#F56C6C;font-weight: bold;">驳回</p>
					<p v-if="scope.row.authStatus==3" style="color:#35333c;font-weight: bold;">加盟到期待续约</p>
				</template>
			</el-table-column>

			<el-table-column prop="status" label="店铺状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.status==0">停用</p>
					<p v-if="scope.row.status==1">正常</p>
				</template>
			</el-table-column>

			<el-table-column prop="createTime" label="注册时间" sortable align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<!-- <el-table-column prop="updateTime" label="更新时间" sortable align="center" :show-overflow-tooltip="true">
			</el-table-column> -->

			<el-table-column  label="操作"  fixed="right" align="center"   width="200">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="writeOffProductsChick(scope.row)">查看选品</el-button>　
					<el-button size="small" type="text" @click="delstore(scope.row.id)">删除</el-button>　　
					<el-button size="small" type="text" v-show="scope.row.authStatus==1" @click="editStatusShow(scope.row)">
						{{scope.row.status ? '禁用':'启用'}}</el-button>
						 <!-- && scope.row.paymentStatus==1 -->
					<el-button v-show="scope.row.authStatus==0" size="small" type="text"
						@click="toExamine(scope.row.id, 1)">通过</el-button>
					<el-button v-show="scope.row.authStatus==0" size="small"
					 type="text" @click="toExamine(scope.row.id, 2)">驳回</el-button>
					　　　　
				</template>
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px 0px 20px;" background :current-page="storeList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="storeList.total"
			@size-change="handleSizeChange">
		</el-pagination>

		<!-- 店铺审核 -->
		<el-dialog style="float:rigin" title="审核" :visible.sync="editDialogVisible" width="35%"
			:closeOnClickModal="false" >
			<div style="padding:0 50px">
				
			</div>
			<div class="app-container" v-if="auditType==2">
				<el-form ref="form" :model="form" :rules="mainFormRules" size="medium" >
					<el-form-item label="驳回原因:">
						<el-col :span="18">
							<el-input v-model="form.refuseReason" placeholder="请输入驳回原因" />
						</el-col>
					</el-form-item>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button :loading="checkLoading" type="primary" v-if="auditType==2"
					@click="editStoreInfoCheck(storeId,2)">驳回</el-button>
				<el-button :loading="checkLoading" type="primary" v-if="auditType==1"
				@click="editStoreInfoCheck(storeId,1)">通过</el-button>
				
				<el-button @click="cannelPass">取 消</el-button>
			</div>
		</el-dialog>
		
		<!-- 禁用 或 启用 -->
		<el-dialog style="float:rigin" :title="formStatus.status ? '禁 用':'启 用'" :visible.sync="editStatusDialogVisible" width="35%"
			:closeOnClickModal="false" >
			<div class="app-container">
				<el-form ref="form" :model="formStatus" :rules="mainFormRules" size="medium">
					<el-form-item label="禁用说明:" v-show="formStatus.status">
						<el-col :span="18">
							<el-input v-model="formStatus.refuseReason" placeholder="请输入禁用说明" />
						</el-col>
					</el-form-item>
					
					<div style="text-align: center;">
						<el-button :loading="toStatusLoading" type="primary" @click="toStatus()">{{formStatus.status ? '禁 用':'启 用'}}
						</el-button>
						<el-button @click="editStatusDialogVisible = false">取 消</el-button>
					</div>
				</el-form>
			</div>
		</el-dialog>


		<!-- 编辑商家 -->
		<el-dialog :closeOnClickModal="false" style="float:rigin" :title="title" :visible.sync="dialogVisible" width="50%" >
			<div class="app-container" style="text-align: center;padding-right:80px">
				<el-form size="medium" label-width="120px">
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<!-- <el-form-item label-width="100px" label="用户登录名:" class='tiny' cleartable style="margin-top: 22px;">
							<el-input style="width: 200px;" v-model="username" placeholder="请输入用户登录名"></el-input>
						</el-form-item>

						<el-button type="primary" @click="getUserList">搜索</el-button>
						<el-button type="primary" @click="username = ''">清空</el-button> -->
						<el-form-item  label="选择用户" v-if="title == '新增'" >
							<el-select filterable v-model="storeInfo.userId" placeholder="请输入用户名称后选择用户" 
							clear  style="width:200px;"
								:remote-method="getUserList"
								:loading="storeLoading"
								remote
								reserve-keyword>
								<el-option v-for="item in accountList" :key="item.id" :value="item.id" :label="item.username">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="用户" v-else >
							<el-input type="text" v-model="storeInfo.username" placeholder="请输入店铺名称" disabled />
						</el-form-item>
					</div>

					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="店铺名称" >
							<el-input type="text" v-model="storeInfo.storeName" placeholder="请输入店铺名称" />
						</el-form-item>
						<el-form-item  label="选择店铺属性" >
							<el-select filterable v-model="storeInfo.storeType" placeholder="请选择" clear
							style="width:200px;">
								<el-option key="0" :value="0" label="线上店铺"></el-option>
								<el-option key="1" :value="1" label="线下店铺"></el-option>
							</el-select>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;"
					v-if="storeInfo.storeType == 1">
						<!-- 线下店铺经营时间 -->
						<!-- 线下店铺配送方式 -->
						<el-form-item  label="经营时间" >
							<el-time-picker
							style="width:200px;"
								is-range
								v-model="storeInfo.businessHours"
								value-format="HH:mm"
								format="HH:mm"
								range-separator="至"
								start-placeholder="开始时间"
								end-placeholder="结束时间"
								placeholder="选择时间范围">
							</el-time-picker>
						</el-form-item>
						<el-form-item  label="配送方式" >
							<el-select filterable v-model="storeInfo.deliveryMethod"  placeholder="请选择" clear
							style="width:200px;">
								<el-option :key="1" :value="1" label="自提/到店"></el-option>
								<el-option :key="2" :value="2" label="快递/物流"></el-option>
								<el-option :key="3" :value="3" label="不配送"></el-option>
							</el-select>
						</el-form-item>
					</div>
					<div>
						<el-form-item v-if="storeId" label="是否推存" cleartable>
							<el-select v-model="storeInfo.isHot" placeholder="请选择"  style="width:200px;">
								<el-option key="0" label="不推荐" :value="false">不推荐</el-option>
								<el-option key="1" label="推荐" :value="true">推荐</el-option>
							</el-select>
						</el-form-item>
						<el-form-item  label="经营类目" >
							<el-select v-model="storeInfo.storeClassId" multiple placeholder="请选择">
								<el-option
								v-for="item in BusinessCategory"
								:key="item.id"
								:label="item.className"
								:value="item.id+''">
								</el-option>
							</el-select>
						</el-form-item>
						
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;" >
						<el-form-item label="联系人">
							<el-input type="text" v-model="storeInfo.linkUser" placeholder="请输入联系人" />
						</el-form-item>
						<el-form-item label="手机号">
							<el-input type="text" v-model="storeInfo.phone" placeholder="请输入手机号" />
						</el-form-item>
					</div>

					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="省/市/区" style="width:800px;">
							<el-select clearable filterable v-model="storeInfo.provinceId" placeholder="请选择省"
								@change="provinceFocus">
								<el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
							<el-select clearable filterable v-model="storeInfo.cityId" placeholder="请选择市"
								 @change="cityFcus">
								<el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
							<el-select clearable filterable v-model="regionId" placeholder="请选择区"
								 @change="districtFcus">
								<el-option v-for="item in districtList" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</div>
					<div>
						<el-form-item label="详细地址" style="width:800px;">
							<el-input type="text" v-model="storeInfo.address" placeholder="请输入详细地址" />
						</el-form-item>
					</div>

					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="店铺Logo" >
							<!-- 图片上传 -->
							<el-upload :class="{hide: store_logo.length>0}" :action="httpUrl" :on-preview="handlePictureCardPreview"
								:file-list="store_logo" :show-file-list="true" :limit="1" list-type="picture-card" :on-remove="handleRemove"
								:before-upload="beforeAvatarUpload" :on-success="onSuccess">
							</el-upload>
						</el-form-item>

						<el-form-item label="营业执照" >
							<!-- license_photo -->
							<el-upload  :class="{hide: licensePhoto.length>0}" :action="httpUrl" :on-preview="handlePictureCardPreview"
								:file-list="licensePhoto" :show-file-list="true" :limit="1" list-type="picture-card" :on-remove="handleRemoveTwo"
								:before-upload="beforeAvatarUpload" :on-success="onSuccessTwo">
							</el-upload>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="证件照片">
							<!-- bank_licence_image -->
							<el-upload :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
								:on-remove="handleRemove1" :file-list="fileList" :show-file-list="true" :limit="5"
								:on-success="onSuccess1">
								<i class="el-icon-plus"></i>
							</el-upload>

						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;"
					v-if="storeInfo.storeType == 1">
					<!-- store_images -->
						<el-form-item label="店铺照片">
							<el-upload :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
								:on-remove="handleRemove1Two" :file-list="fileListTwo" :show-file-list="true" :limit="5"
								:on-success="onSuccess1Two">
								<i class="el-icon-plus"></i>
							</el-upload>

						</el-form-item>
					</div>

					<div>
						<el-form-item label="店铺简介" style="width:800px;">
							<el-input :rows="5" type="textarea" maxlength="50" show-word-limit v-model="storeInfo.storeIntro"
								placeholder="请输入店铺简介" />
						</el-form-item>
						<!-- <div style="text-align: start;margin: 10px;">店铺简介</div>
						<el-form-item>
							<div id="lpc-quill" class="quill">
								<el-upload class="upload-demo" v-show="false" ref="upload" :action="httpUrl"
									:before-upload="beforeAvatarUpload" :on-success="upScuccess" :on-error="uploadError" />
								<quill-editor v-model="storeInfo.storeIntro" ref="myQuillEditor" class="editer" :options="editorOption"
									@ready="onEditorReady($event)">
								</quill-editor>
							</div>
						</el-form-item> -->
					</div>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button v-show="title=='新增'" type="primary" @click="sure" :loading="sureLoading">添 加</el-button>
				<el-button v-show="title=='编辑'" type="primary" @click="edit" :loading="editLoading">修 改</el-button>
				<el-button @click="dialogVisible = false">取 消</el-button>
			</div>
		</el-dialog>


		<!-- 查看店铺各种照片 -->
		<el-dialog title="照片" :visible.sync="showContentDialog" width="50%" :closeOnClickModal="false">
			<div>
				<div>
					<img style="width: 100%;" :src="storeInfo.storeLogo" />
				</div>
				<div>
					<img style="width: 100%;" :src="storeInfo.legalIdFace" />
				</div>
				<div>
					<img style="width: 100%;" :src="storeInfo.legalIdBack" />
				</div>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="showContentDialog = false">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 图片查看 -->
		<el-dialog :visible.sync="dialogImg" :closeOnClickModal="false" width="700px" title="加盟备注">
			<div style="text-align: center;">
				{{popupImageUrl?popupImageUrl:'暂无'}}
			</div>
			<div style="height:30px"></div>
			<div style="text-align: center;">
				<el-button type="primary" @click="dialogImg = false">关 闭</el-button>
			</div>
		</el-dialog>
		

		<!-- 查看选品 -->
		<el-dialog  title="查看选品" :visible.sync="inviteDialogVisible" width="1200px" :close-on-click-modal="false">
			<el-table :data="writeOffProducts" stripe style="width: 100%;" :header-cell-style="headClass" height="400"
				v-loading="writeOffProductsLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" >
				<el-table-column prop="goodsName" label="商品名称" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="price" label="零售价格" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
					<template slot-scope="scope">
						<span>￥ {{ scope.row.price}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="salesSum" label="销量" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="stock" label="库存" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="saleNum" label="核销数量" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="createTime" label="选品时间" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
			</el-table>
			<!-- <el-pagination style="margin: 20px;" background :current-page="writeOffProducts.pageNum"
				@current-change="pageInviteChange" :page-sizes="[10, 20, 50, 100, 150, 200]" layout="total, sizes, prev, pager,next"
				:total="writeOffProducts.total" @size-change="handleInviteSizeChange">
			</el-pagination> -->
			<div style="text-align: center;">
				<el-button @click="inviteDialogVisible = false">返回</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
    // import moment from '../../common/moment.js'
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('offstore');

	import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";
import { number } from 'echarts';
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				title: '',
				httpUrl: urls,
				loading: false,
				storeList: [{}], //列表
				dialogVisible: false, // 审核
				editDialogVisible: false, // 编辑
				showContentDialog: false, //查看证件照片
				editStatusDialogVisible: false,//禁用或启用
				formStatus:{},
				accountList: [],
				username: '',
				regionId:'',
				storeInfo: {
					userId: "",
					isHot: "",
					storeLogo: "",
					storeName: "",
					storeIntro: "",
					type: "",
					linkUser: "",
					phone: "",
					legalIdNumber: "",
					legalIdFace: "",
					legalIdBack: "",
					provinceId: "",
					cityId: "",
					regionId: "",
					province: "",
					city: "",
					area: "",
					address: "",
					storeType:'', 
				},
				store_logo: [], //店铺logo
				provinceList: {},
				cityList: {},
				districtList: {},
				storeId: '', //授权用户id
				form: {
					refuseReason: ""
				},
				mainFormRules: {
					refuseReason: {
						required: true,
						message: "请输入驳回原因",
						trigger: "blur"
					},
				},
				page: {
					pageNum: 1,
					pageSize: 10,
					invitePageNum: 1,
					invitePageSize: 10
				},
				searchInfo: {
					authStatus: '',
					status: '',
				},
				editorOption: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
									header: 1,
								},
								{
									header: 2,
								},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
									list: "ordered",
								},
								{
									list: "bullet",
								},
								], // 列表
								[{
									script: "sub",
								},
								{
									script: "super",
								},
								], // 上下标
								[{
									indent: "-1",
								},
								{
									indent: "+1",
								},
								], // 缩进
								[{
									direction: "rtl",
								},], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								},], // 字体大小
								[{
									color: [],
								},
								{
									background: [],
								},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								},], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function (value) {
									// console.log(value)
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},

						},
					},
					theme: "snow",
				},
				dialogVisibleDetails:false, //logo查看弹窗
				storeLoading: false,
				auditInfo: {}, //店铺审核信息
				auditType: '', //店铺审核类型

				licensePhoto:[], //店铺营业执照
				fileList: [], //证件照片
				fileListTwo: [], //店铺照片

				dialogImg:false,
				popupImageUrl:'',

				BusinessCategory:[], //经营类别

				//查看选品
				inviteDialogVisible: false,
				writeOffProducts: [],
				writeOffProductsLoading: false,
				chinaStoreID: '',

				checkLoading: false,
				sureLoading: false,
				editLoading: false,
			};
		},

		methods: {
			leaveTime(value){ //格式化时间  年-月日
				return this.$moment(value).format('YYYY-MM-DD');
			},
			pageInviteChange(data) { //查看选品
				this.page.invitePageNum = data
				this.writeOffProductsLoading = false
				this.showWriteOff()
			},
			handleInviteSizeChange(val) { //查看选品
				this.page.invitePageSize = val
				this.writeOffProductsLoading = false
				this.showWriteOff()
			},
			showWriteOff() { //查看选品
				this.writeOffProductsLoading = true;
				let data = {
					chainId: this.chainID, //this.chainID
					storeId: this.chinaStoreID //this.chinaStoreID
					// pageNum: this.page.invitePageNum,
					// pageSize: this.page.invitePageSize,
				}
				this.$api.getWriteOffProductsByID(data).then((res) => { 
					// console.log('查看选品---', res)
					if (res.state == 'success') {
						// console.log('查看选品---', res.data.list[0])
						this.writeOffProducts = res.data
					}else{
						this.$message({
							type: 'error',
							message: res.message
						});
					}
					this.writeOffProductsLoading = false
				})
			},
			writeOffProductsChick(row){
				// console.log('234--', row)

				this.chinaStoreID = row.storeId;
				this.chainID = row.chainId;
				this.writeOffProducts=[];
				this.showWriteOff();
				this.inviteDialogVisible = true;
			},
			delstore(id){
				var str = "确认解除该店铺与品牌关系, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					
					this.$api.deleteByIdRelationship(id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							// this.page.pageNum = 1;
							this.getStoreList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
				
			},
			getBusinessCategoryList(){
				let data={
					pageSize: 100,
					pageNum: 1,
					isShow: true
				}
				this.$api.BusinessCategoryList(data).then((res) => {
						if (res.state == 'success') {
							// console.log('134--', res.data)
							this.BusinessCategory = res.data.list
						}else{
							this.$message.error(res.message);
						}
						this.storeLoading = false
					})
			},
			look(e) { //图片查看
				this.popupImageUrl = e;
				this.dialogImg = true;
			},
			//上传店铺logo
			onSuccess(response, file, fileList) {
				// console.log(response);
				this.store_logo.push({
					url: response.message
				})
			},
			handleRemove(file, fileList) {
				this.store_logo = [];
			},

			onSuccess1(response, file) {
				// console.log(response)
				this.fileList.push({
					"url": response.message
				})
				// console.log("asda", this.fileList)
			},
			handleRemove1(file, fileList) {
				if (file.response) {
					this.fileList.remove(file.response.message);
				}
				this.fileList.remove(file.url);
			},
			onSuccess1Two(response, file) {
				// console.log(response)
				this.fileListTwo.push({
					"url": response.message
				})
			},
			handleRemove1Two(file, fileList) {
				if (file.response) {
					this.fileListTwo.remove(file.response.message);
				}
				this.fileListTwo.remove(file.url);
			},
			handleRemove(file, fileList) {
				if (file.response) {
					this.fileList.remove(file.response.message);
				}
				this.fileList = this.fileList.filter(item => item.uid !== file.uid)
			},
			handleRemoveTwo(file, fileList) {
				this.licensePhoto = [];
			},
			handlePictureCardPreview(file) {
				// this.dialogImageUrl = file.url;
				// this.dialogVisibleImg = true;

				this.popupImageUrl = file.url;
				this.dialogImg = true;
			},
			

			findDetail(string) { //查看店铺描述和logo
				this.dialogVisibleDetails = true;
				this.images = string
				// this.detailType = type;
				// if (type == 1) {
				// 	this.detail = string;

				// }
				// if (type == 2) {
				// 	this.images = string.split(",");
				// }
			},
			toExamine(id,num){ // 查询店铺详细信息
				//审核驳回弹窗打开
				this.form.refuseReason = ""; //驳回原因
					
				this.auditType = num; //审核类型
				this.auditInfo = {}; //审核数据信息
				this.editDialogVisible = true;
				this.storeId = id
				
			},
			getUserList(e) {
				this.storeLoading = true
				//查询用户账号
				if (e.length >= 2) {
					var data = {
						username: e
					}
					this.$api.getUserNameList(data).then((res) => {
						if (res.state == 'success') {
							if (res.data && res.data.length) {
								// this.$message({
								// 	message: '查询成功，请选择用户！',
								// 	type: 'success'
								// });
								this.accountList = res.data
							} else {
								this.$message.error("未查询到用户");
							}
						}else{
							this.$message.error(res.message);
						}
						this.storeLoading = false
					})
				}else{
					this.accountList = []
				}

				
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.getStoreList()
			},
			showFile(info) {
				this.showContentDialog = true
				this.storeInfo.storeLogo = info.storeLogo
				this.storeInfo.legalIdFace = info.legalIdFace
				this.storeInfo.legalIdBack = info.legalIdBack
			},
			//店铺提交审核
			editStoreInfoCheck(id, authStatus) {
				if (authStatus == 2) {
					//通过驳回
					var data = {
						id: this.storeId,
						authStatus: authStatus,
						reason: this.form.refuseReason
					}
				} else {
					//通过审核
					var data = {
						id: id,
						authStatus: authStatus
					}
				}
				this.checkLoading = true;
				this.$api.auditChainStoreRelationship(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false
						this.getStoreList()
					} else {
						this.$message.error(res.message);
					}
					this.checkLoading = false;
				})

			},

			//审核驳回弹窗关闭
			cannelPass() {
				this.editDialogVisible = false
			},
			
			//查询市
			provinceFocus(e) {
				let obj = {};
				obj = this.provinceList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeInfo.province = obj.name
				this.storeInfo.cityId = ""
				this.storeInfo.regionId = ""
				this.regionId = ""
				this.cityList = {}
				this.districtList = {}
				if (e) {
					this.$api.getAreasFive(e).then((res) => {
						if (res.state == 'success') {
							this.cityList = res.data
						}
					})
				}
			},
			//查询区
			cityFcus(e) {
				let obj = {};
				obj = this.cityList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeInfo.city = obj.name
				this.storeInfo.regionId = ""
				this.regionId = ""
				this.districtList = {}
				if (e) {
					this.$api.getAreasFive(e).then((res) => {
						if (res.state == 'success') {
							this.districtList = res.data
						}
					})
				}

			},
			districtFcus(e) {
				this.storeInfo.areaId = e;
				let obj = {};
				obj = this.districtList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeInfo.area = obj.name
			},
			// 店铺编辑弹窗
			dialogVisibleFun(id) {
				this.storeInfo = {}
				this.storeId = ""
				this.regionId = '';
				this.store_logo = [];
				this.licensePhoto = [];
				this.fileList = [];
				this.fileListTwo = [];

				if (id) {
					this.storeId = id
					this.$api.getStoreId(this.storeId).then((res) => {
						res.data=JSON.parse(this.$decrypt(res.data)).data
						if (res.state == 'success') {
							// console.log('更具ID查询---',res.data)
							this.storeInfo = res.data;
							this.username = res.data.username;
							this.storeInfo.storeClassId = res.data.storeClassId.split(',');
							
							// this.getUserList();

							if(this.storeInfo.storeLogo){
								this.store_logo.push({
									url: this.storeInfo.storeLogo
								})
							}else{
								this.store_logo = []
							}
							if(this.storeInfo.licensePhoto){
								this.licensePhoto.push({
									url: this.storeInfo.licensePhoto
								})
							}else{
								this.licensePhoto = []
							}

							if(res.data.businessHours){
								this.storeInfo.businessHours = res.data.businessHours.split('-')
							}
							// this.fileList //证件照片
							// this.fileListTwo //店铺照片
							if(res.data.bankLicenceImage){ //证件照片
								let arr = res.data.bankLicenceImage.split(',')
								arr.map(item => { 
									this.fileList.push({
										url:item
									})
								})
							}
							if(res.data.storeImages){  //店铺照片
								let arrTwo = res.data.storeImages.split(',')
								arrTwo.map(item => { 
									this.fileListTwo.push({
										url:item
									})
								})
							}

							if (this.storeInfo.provinceId) {
								this.$api.getAreasFive(this.storeInfo.provinceId).then((res) => {
									if (res.state == 'success') {
										this.cityList = res.data
									}
								})
							}
							if (this.storeInfo.cityId) {
								this.$api.getAreasFive(this.storeInfo.cityId).then((res) => {
									if (res.state == 'success') {
										this.districtList = res.data
									}
								})
							}
							this.regionId = res.data.regionId;

							
						}
					})
				} 
				this.dialogVisible = true;
			},
			//新增店铺
			sure() {
				// this.storeInfo.storeLogo = this.logo; //店铺logo
				this.storeInfo.regionId = this.regionId;
				if(this.licensePhoto.length == 1){
					this.storeInfo.licensePhoto = this.licensePhoto[0].url; //营业执照
				}
				if(this.store_logo.length == 1){
					this.storeInfo.storeLogo = this.store_logo[0].url; //营业执照
				}
				// this.storeInfo.storeLogo = this.store_logo[0].url; //logo
				this.storeInfo.storeClassId = this.storeInfo.storeClassId.join(',');
				let arrOne = [];
				
				this.fileList.map(item => { //证件照片
					arrOne.push(item.url)

				})
				this.storeInfo.bankLicenceImage = arrOne.join(",")
				
				if(this.storeInfo.storeType == 1){
					let arrTwo = [];
					this.storeInfo.businessHours = this.storeInfo.businessHours.join("-"); //营业时间
					this.fileListTwo.map(item => { //店铺照片
						arrTwo.push(item.url)
					})
					this.storeInfo.storeImages = arrTwo.join(",")
				}

				this.sureLoading = true;
				// console.log('新增数据---',this.storeInfo)

				this.$api.addStore(this.storeInfo).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});

						this.dialogVisible = false;
						this.getStoreList();
					} else {
						this.$message.error(res.message);
					}
					this.sureLoading = false;
				})

			},
			//编辑
			edit() {				
				let data={
					id: this.storeId,
					userId: this.storeInfo.userId,
					storeName: this.storeInfo.storeName,
					storeType: this.storeInfo.storeType,
					isHot: this.storeInfo.isHot,
					storeClassId: this.storeInfo.storeClassId.join(','),
					linkUser: this.storeInfo.linkUser,
					phone: this.storeInfo.phone,

					regionId: this.storeInfo.areaId || this.regionId,
					area: this.storeInfo.area,
					cityId: this.storeInfo.cityId,
					city: this.storeInfo.city,
					provinceId: this.storeInfo.provinceId,
					province: this.storeInfo.province,
					address: this.storeInfo.address,
					// regionId: this.regionId,

					storeIntro: this.storeInfo.storeIntro,
					licensePhoto: '',
					storeLogo: '',
					bankLicenceImage:'',
					businessHours: '',
					storeImages:'',
				}
				if(this.licensePhoto.length == 1){
					data.licensePhoto = this.licensePhoto[0].url; //营业执照
				}
				if(this.store_logo.length == 1){
					data.storeLogo = this.store_logo[0].url; //营业执照
				}
				let arrOne = [];
				this.fileList.map(item => { //证件照片
					arrOne.push(item.url)
				})
				data.bankLicenceImage = arrOne.join(",")
				if(this.storeInfo.storeType == 1){
					let arrTwo = [];
					data.businessHours = this.storeInfo.businessHours.join("-"); //营业时间
					this.fileListTwo.map(item => { //店铺照片
						arrTwo.push(item.url)
					})
					data.storeImages = arrTwo.join(",")
				}
				this.editLoading = true;
				// console.log('编辑数据---', data)
				this.$api.editStore(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisible = false;
						this.getStoreList();
					} else {
						this.$message.error(res.message);
					}
					this.editLoading = false;
				})
			},
			editStatusShow(store){
			
				if(store.status){
					var strs = "确认禁用该店铺, 是否继续?"
				}else{
					var strs = "确认启用该店铺, 是否继续?"
				}
				
				console.log(strs);
				this.$confirm(strs, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					
					this.$api.stopEnableById(store.id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							// this.page.pageNum = 1;
							this.getStoreList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//禁用启用
			toStatus() {
				let str;
				this.toStatusLoading = true;
				this.$api.editStoreBlockUpOrStartUsing(this.formStatus).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.getStoreList();
						this.editStatusDialogVisible = false;
					} else {
						this.$message.error(res.message);
					}
					this.toStatusLoading = false;
				})
				// if (this.formStatus == 0) {
				// 	str = "此操作将启用该店铺账号, 是否继续?"
				// } else {
				// 	str = "此操作将禁用该店铺账号, 是否继续?"
				// }
				// this.$confirm(str, '提示', {
				// 	confirmButtonText: '确定',
          		// 	cancelButtonText: '取消',
				// 	type: 'warning'
				// }).then(() => {
				// 	console.log('点击了确定')
				// 	that.$api.editStoreBlockUpOrStartUsing(that.formStatus).then((res) => {
				// 		if (res.state == 'success') {
				// 			that.$message({
				// 				message: res.message,
				// 				type: 'success'
				// 			});
				// 			that.getStoreList();
				// 			that.editStatusDialogVisible = false;
				// 		} else {
				// 			that.$message.error(res.message);
				// 		}
				// 	})
				// }).catch(() => {
				// 	this.$message({
				// 		type: 'info',
				// 		message: '已取消'
				// 	});
				// });
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			pageChange(data) {
				this.page.pageNum = data
				this.getStoreList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getStoreList()
			},
			getStoreList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					storeName: this.searchInfo.storeName,
					// type: this.searchInfo.type,
					authStatus: this.searchInfo.authStatus,
					// orderType: this.searchInfo.orderType,
					// username: this.searchInfo.username,
					// isHot: this.searchInfo.isHot,
					status: this.searchInfo.status,
					// storeType: this.searchInfo.storeType
				}

				this.$api.ChainStoreRelationship(data).then((res) => { //管理列表
					// console.log('数据表格---', res)
					if (res.state == 'success') {
						this.storeList = res.data
					}else{
						this.$message.error(res.message);
					}
					this.loading = false
				})
			},
			changeNull(row, column, cellValue) {
				if (cellValue) {
					return cellValue;
				} else if (cellValue == 0) {
					return "0";
				} else {
					return "暂无";
				}
			},

			// 上传身份证正面图片
			upLoadLegalIdFace(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					// console.log('列表:', res);
					this.storeInfo.legalIdFace = res.data
				})
			},
			// 上传身份证反面图片
			upLoadLegalIdBack(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					// console.log('列表:', res);
					this.storeInfo.legalIdBack = res.data
				})
			},

			// 上传店铺logo点击文件触发
			handlePreview(file) {
				// console.log(file)
			},
			// 上传店铺logo上传图片前，筛选
			beforeAvatarUpload(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
					return false;
				};
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				};
				return isLt2M, imgStr;
			},
			
			// 上传营业执照点击文件触发
			handlePreviewTwo(file) {
				// console.log(file)
			},
			// 上传营业执照 上传图片前，筛选
			beforeAvatarUploadTwo(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
					return false;
				};
				let imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				};
				return isLt2M, imgStr;
			},
			//上传营业执照
			onSuccessTwo(response, file, fileList) {
				// console.log(response);
				this.licensePhoto.push({
					url : response.message
				});
			},

			upScuccess(res, file) {
				const quill = this.$refs.myQuillEditor.quill;
				if (res.state == "success" && res.message !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
			},
			uploadError() {
				this.$message.error("图片上传失败");
			},
			onEditorReady(editor) {
				// 准备编辑器
				console.log(editor);
			}
		},
		created() {
			this.getStoreList();
			//查询省
			// this.$api.getAreasFive(0).then((res) => {
			// 	if (res.state == 'success') {
			// 		this.provinceList = res.data
			// 	}
			// })
			// this.getBusinessCategoryList();
		}

	};
</script>

<style scoped>
	.demo-table-expand {
		font-size: 0;
		margin-left: 90px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		width: 100px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader1 .el-upload {
		border: 1px dashed #d9d9d9;
		width: 200px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 100px;
		height: 100px;
		line-height: 100px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>